import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "joinValues"
})
export class JoinValuesPipe implements PipeTransform {

    transform(values: any[], propertyName?: string, separator?: string): string {
        let elements = [...values];
        if (propertyName) {
            elements = values.map(v => v[propertyName]);
        }
        return elements.join(separator);
    }
}
